/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cumulative sum smooths out local noise and reveals large-scale trends. Its turning points frequently coincide with the replication origin and terminus in bacterial genomes.`)
};

const es_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La suma acumulada suaviza el ruido local y revela tendencias a gran escala. Sus puntos de inflexión coinciden con frecuencia con el origen y el terminal de replicación en genomas bacterianos.`)
};

const de_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die kumulative Summe glättet lokales Rauschen und zeigt großflächige Trends. Ihre Wendepunkte fallen häufig mit dem Replikationsursprung und -terminus in bakteriellen Genomen zusammen.`)
};

const nl_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De cumulatieve som vlakt lokale ruis af en onthult grootschalige trends. De keerpunten ervan vallen vaak samen met de replicatie-oorsprong en -terminus in bacteriële genomen.`)
};

const fr_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La somme cumulée lisse le bruit local et révèle les tendances à grande échelle. Ses points d'inflexion coïncident fréquemment avec l'origine et le terminus de réplication dans les génomes bactériens.`)
};

const it_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La somma cumulativa attenua il rumore locale e rivela tendenze su larga scala. I suoi punti di svolta coincidono spesso con l'origine di replicazione e il terminus nei genomi batterici.`)
};

const pt_br2_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A soma acumulada suaviza o ruído local e revela tendências em larga escala. Seus pontos de inflexão frequentemente coincidem com a origem e o término de replicação em genomas bacterianos.`)
};

const pt_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A soma cumulativa suaviza o ruído local e revela tendências de grande escala. Os seus pontos de inflexão coincidem frequentemente com a origem e o término de replicação em genomas bacterianos.`)
};

const ja_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累積和は局所的なノイズを平滑化し、大規模な傾向を明らかにします。その変曲点は、細菌ゲノムの複製起点や終結点としばしば一致します。`)
};

const zh_gcskew_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累积和能够平滑局部噪声，揭示大尺度趋势。其转折点常常与细菌基因组中的复制起点和终点重合。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_faq_a2", locale)
	if (locale === "en") return en_gcskew_faq_a2(inputs)
	if (locale === "es") return es_gcskew_faq_a2(inputs)
	if (locale === "de") return de_gcskew_faq_a2(inputs)
	if (locale === "nl") return nl_gcskew_faq_a2(inputs)
	if (locale === "fr") return fr_gcskew_faq_a2(inputs)
	if (locale === "it") return it_gcskew_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_faq_a2(inputs)
	if (locale === "pt") return pt_gcskew_faq_a2(inputs)
	if (locale === "ja") return ja_gcskew_faq_a2(inputs)
	return zh_gcskew_faq_a2(inputs)
};